module.exports = __webpack_public_path__ + "img/LOGO_letter_square.00380da2.png";